'use client';

import type { ChangeEvent, FC, HTMLProps, ReactNode } from 'react';

interface CheckboxProps extends HTMLProps<HTMLInputElement> {
  disabled?: boolean;
  value: string;
}

interface CheckboxGroupProps {
  children: (Checkbox: FC<CheckboxProps>) => ReactNode;
  name: string;
  value: string[];
  onChange: (newValue: string[]) => void;
}

export const CheckboxGroup = (props: CheckboxGroupProps) => {
  const { children, name, value: checkedValues, onChange } = props;

  const onCheckboxChange = (
    checkboxValue: string,
    event: ChangeEvent<HTMLInputElement>,
  ) => {
    if (event.target.checked)
      onChange(checkedValues.concat(checkboxValue));
    else
      onChange(checkedValues.filter(value => value !== checkboxValue));
  };

  const Checkbox = (checkboxProps: CheckboxProps) => {
    const { value: checkboxValue, disabled, ...rest } = checkboxProps;

    const checked = checkedValues
      ? checkedValues.includes(checkboxValue)
      : false;

    return (
      <input
        {...rest}
        type="checkbox"
        name={name}
        disabled={disabled}
        checked={checked}
        onChange={onCheckboxChange.bind(null, checkboxValue)}
        value={checkboxValue}
      />
    );
  };

  return children(Checkbox);
};
